import { jsxs as L, jsx as P } from "react/jsx-runtime";
import { c as b } from "react/compiler-runtime";
import { Button as j, CircularProgress as v } from "@mui/material";
import { forwardRef as C } from "react";
const R = C((m, h) => {
  const t = b(23);
  let n, a, i, l, r, d;
  t[0] !== m ? ({
    loading: r,
    loadingIndicator: i,
    loadingPosition: d,
    children: n,
    disabled: a,
    ...l
  } = m, t[0] = m, t[1] = n, t[2] = a, t[3] = i, t[4] = l, t[5] = r, t[6] = d) : (n = t[1], a = t[2], i = t[3], l = t[4], r = t[5], d = t[6]);
  const c = r === void 0 ? !1 : r, u = d === void 0 ? "center" : d;
  let f;
  t[7] !== i ? (f = i ?? /* @__PURE__ */ P(v, { color: "inherit", size: 16 }), t[7] = i, t[8] = f) : f = t[8];
  const e = f, p = c && u === "start", x = c && u === "end", B = c && u === "center", y = a || c, w = B ? e : null;
  let o;
  t[9] !== e || t[10] !== p ? (o = p ? /* @__PURE__ */ P("span", { style: {
    display: "inline-flex",
    marginRight: 8
  }, children: e }) : null, t[9] = e, t[10] = p, t[11] = o) : o = t[11];
  let s;
  t[12] !== e || t[13] !== x ? (s = x ? /* @__PURE__ */ P("span", { style: {
    display: "inline-flex",
    marginLeft: 8
  }, children: e }) : null, t[12] = e, t[13] = x, t[14] = s) : s = t[14];
  let g;
  return t[15] !== n || t[16] !== l || t[17] !== h || t[18] !== y || t[19] !== w || t[20] !== o || t[21] !== s ? (g = /* @__PURE__ */ L(j, { ref: h, disabled: y, ...l, children: [
    w,
    o,
    n,
    s
  ] }), t[15] = n, t[16] = l, t[17] = h, t[18] = y, t[19] = w, t[20] = o, t[21] = s, t[22] = g) : g = t[22], g;
});
R.displayName = "LoadingButton";
export {
  R as LoadingButton
};
